
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { Box } from '@/ui/components/Box';
  import Status from '@/ui/components/integrations/Status.vue';
  import { computed, defineComponent } from 'vue';

  export default defineComponent({
    components: {
      Status,
      Box,
    },
    setup() {
      const store = useIntegrationDetailsStore();

      return {
        translation: computed(() => store.properties),
        integration: store.integration!,
      };
    },
  });
